import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Carrier = Loadable(lazy(() => import('./Carrier')));

const CarrierRoutes = [
	{
		path: '/carrier',
		element: <Carrier />,
		auth: authRoles.admin,
	},
];

export default CarrierRoutes;
